import { TextInput, SelectInput, PhoneInput, DateInput, NoYesRadio, Checkbox, RadioOptions } from "../Inputs";
import { ToolTip } from "../";
import "./InputField.css";

export default function InputField({
    type,
    inputLabel,
    identifier,
    onChange,
    value,
    mandatory = true,
    options = null,
    minDate = null,
    maxDate = null,
    disabled = false,
    defaultOption = "",
    hint,
}) {
    const renderInput = () => {
        const inputProps = { identifier, mandatory, onChange, value, disabled };

        switch (type) {
            case "text":
                return <TextInput type={type} {...inputProps} />;
            case "email":
                return <TextInput type={type} {...inputProps} />;
            case "select":
                return <SelectInput {...inputProps} options={options} defaultOption={defaultOption} />;
            case "date":
                return <DateInput {...inputProps} min={minDate} max={maxDate} />;
            case "phone":
                return <PhoneInput {...inputProps} />;
            case "noyesradio":
                return <NoYesRadio {...inputProps} />;
            case "checkbox":
                return <Checkbox {...inputProps} />;
            case "radiooptions":
                return <RadioOptions {...inputProps} options={options} />;
            default:
                return null;
        }
    };

    return (
        <div className="input-field-container fade-in" data-type={type}>
            <label className="input-label" htmlFor={identifier}>
                {inputLabel}
                {mandatory && <span style={{ color: "red", fontWeight: "bold" }}> *</span>}
                {hint &&
                    <ToolTip hintText={hint} />
                }
            </label>
            {renderInput()}
        </div>
    );
}